import React, {useEffect, useRef} from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdyenCheckout from "@adyen/adyen-web";
import "@adyen/adyen-web/dist/adyen.css";
import { getRedirectUrl } from "../../data/redirect";
import {data} from "../../data/data";
import Logo from "../../components/Logo";
import MethodInfo from "../../components/MethodInfo";
import { useTranslation } from "react-i18next";

export const PaymentContainer = () => {
  return (
    <div id="payment-page">
      <div className="outer">
        <Logo />
        <div className="inner">
          <Checkout />
        </div>
      </div>
    </div>
  );
}

const Checkout = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const paymentContainer = useRef(null);
  let { type } = useParams();

  useEffect(() => {
    const { session, config } = data;

    if (!session || !paymentContainer.current || !session.id || !session.sessionData) {
      navigate(`/status/error?reason=${encodeURI(t('invalid session'))}`, { replace: true });
      return;
    }

    const createCheckout = async () => {
      let redirection = false;
      const checkout = await AdyenCheckout({
        ...config,
        showPayButton: true,
        session: {
          id: session.id,
          sessionData: session.sessionData
        },
        onPaymentCompleted: (response: any, _component: any) =>
          navigate(getRedirectUrl(response.resultCode), { replace: true }),
        onError: (error: any, _component: any) => {
          console.error(error);
          redirection = true;
          navigate(`/status/error?reason=${error.message}`, { replace: true });
        },
      });

      data.redirectUrl = checkout.options.returnUrl;

      if (!type && checkout.paymentMethodsResponse && checkout.paymentMethodsResponse.paymentMethods.length === 1) {
        type = checkout.paymentMethodsResponse.paymentMethods[0].type;
      }

      if (paymentContainer.current && type) {
        const cardConfiguration = {
          hasHolderName: true,
          holderNameRequired: true,
        };
        checkout.create(type, cardConfiguration).mount(paymentContainer.current);
        return;
      }
      if (!redirection) {
        data.paymentMethods = checkout.paymentMethodsResponse.paymentMethods;
        navigate(`/select`, {replace: true});
      }
    }

    createCheckout();
  }, [type, navigate])

  return (
    <div className="payment-container">
      <MethodInfo type={type} />
      <div ref={paymentContainer} className="payment" />
    </div>
  );
}
